module.exports = __webpack_public_path__ + "img/DE03478.b608504d.png";